import { useEffect, useRef } from 'react';

type VisibilityChangeCallbacks = {
  active?: (() => void)[];
  hidden?: (() => void)[];
};

export default function usePageVisibilityChange({
  active = [],
  hidden = [],
}: VisibilityChangeCallbacks = {}) {
  const activeRef = useRef<(() => void)[]>(active);
  const hiddenRef = useRef<(() => void)[]>(hidden);

  useEffect(() => {
    activeRef.current = active;
    hiddenRef.current = hidden;
  }, [active, hidden]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.debug('Tab is now active again');
        activeRef.current.forEach((cb) => cb());
      } else {
        console.debug('Tab is hidden');
        hiddenRef.current.forEach((cb) => cb());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}
